import { ICArea } from "./icarea";
import { ICAreaType } from "./icareatype";
import { ICMetaDescription } from "./icmetadescription";
import { ICMonitor } from "./icmonitor";
import { ICNuc } from "./icnuc";
import { ICSchedule } from "./icschedule";

export class ICSchedulation {
  Area: ICArea;
  AreaType: ICAreaType;
  DeleteDate: string;
  Id: number;
  IdGuid: string;
  InsertDate: string;
  LastEditDate: string;
  MetaDescription: ICMetaDescription;
  MetaValue: string;
  Monitor: ICMonitor;
  Nuc: ICNuc;
  Schedule: ICSchedule;

  constructor(data?: Partial<ICSchedulation>) {
    Object.assign(this, data);
  }
}
